// extracted by mini-css-extract-plugin
export default {"logo":"logo__logo--ON1sB","link":"logo__link--kHRkV"};